import { useState, useMemo, useCallback, useEffect, useContext } from 'react'
import algoliasearch from 'algoliasearch/lite'
import debounce from 'lodash.debounce'
import LanguageContext from '../contexts/languageContext'
import * as Helpers from '../helpers/search/group'

const useSearch = () => {
  const [query, setQuery] = useState('')
  const [result, setResult] = useState([])
  const [isVisible, setIsVisible] = useState(false)
  const [isSearchMobileActive, setIsSearchMobileActive] = useState(false)
  const { lang } = useContext(LanguageContext)
  const searchClient = useMemo(() => algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_ADMIN_KEY), [])

  const onSearch = useCallback(
    (query, lang) => {
      const searchIndex = searchClient.initIndex(lang)

      if (query) {
        searchIndex
          .search(query)
          .then(({ hits }) => {
            const data = Helpers.groupDataByCategory(hits)

            setResult(data)
            setIsVisible(true)
          })
          .catch(error => {
            console.log(error)
            setIsVisible(false)
          })
      }
    },
    [searchClient]
  )

  const onSearchDebounced = useMemo(() => debounce(onSearch, 500), [onSearch])

  const onChangeQuerySearch = useCallback(({ target: { value } }) => setQuery(value), [])

  const onInactivateEscPress = useCallback(
    event => {
      if (event.key === 'Escape') {
        setIsVisible(false)
      }
      if (event.key === 'Enter' && query) {
        onSearch(query, lang)
      }
    },
    [query, lang, onSearch, setIsVisible]
  )

  useEffect(() => {
    document.addEventListener('keydown', onInactivateEscPress)

    return () => {
      document.removeEventListener('keydown', onInactivateEscPress)
    }
  }, [onInactivateEscPress])

  useEffect(() => {
    if (query) {
      onSearchDebounced(query, lang)
    } else {
      setIsVisible(false)
    }
  }, [query, lang, onSearchDebounced, setIsVisible])

  useEffect(() => {
    setQuery('')
  }, [lang])

  return {
    isSearchMobileActive,
    setIsSearchMobileActive,
    isVisible,
    setIsVisible,
    query,
    result,
    onChangeQuerySearch,
  }
}

export default useSearch
